export default __webpack_public_path__ + "static/media/230.230169c3.png";